import { useEffect, useState } from "react";
import { useParams, } from "react-router-dom";
import { GenericTable, Spinner, Pagination } from "../../../Components/Common";
import { dispatchColumns, dispatchLabels, STATUS_COLORS, TABS, } from "./constants";
import { formatDateDDMMYYYY, toProperCase } from "../../../Utils";
import { useMRR } from "../Hooks/useMRR";
import { useDispatchNote } from "../Hooks/useDispatchNote";

const DNComparison = () => {
    const { fetchMRRDNMaterials,loading: loadingDispatch } = useMRR();
    const [dispatchData, setDispatchData] = useState(null);
    const [dispatchNotes, setDispatchNotes] = useState([]);
    const { instanceId } = useParams();
  
    const [activeTab, setActiveTab] = useState(TABS.DN);
    const { loading: loadingDN, fetchDispatchNotes, onPageChange: onPageChangeDN, onPageSizeChange: onPageSizeChangeDN, totalPages:totalPagesDN, rowsPerPage:rowsPerPageDN, page:pageDN, } = useDispatchNote();

    const loadMRRDNData = async () => {
        const dispatchData = await fetchMRRDNMaterials(instanceId,);
        setDispatchData(dispatchData);
    };
    const getDispatchNotes = async () => {
        const dispatchNotes = await fetchDispatchNotes({ mrr: instanceId, });
        setDispatchNotes(dispatchNotes);
    }
    // Load DN Materials
    useEffect(() => {
        if (activeTab === TABS.DN) {
            loadMRRDNData();
        }
    }, [instanceId]);

    useEffect(() => {
        if (activeTab === TABS.DN) {
            getDispatchNotes();
        }
    }, [pageDN, rowsPerPageDN]);


    const renderDNMRRTable = (column, row) => {
        if (column === "product_name") {
            return (
                <div>
                    {row.product_name}
                    <span className="text-xs text-gray-500 flex flex-wrap">
                        {row.specification}
                    </span>
                    <span className="text-xs text-gray-500 flex flex-wrap">
                        {row.UOM}
                    </span>
                </div>
            );
        }
        if (
            ["requested_quantity", "total_dispatched_quantity", "remaining_quantity"].includes(column)
        )
            return Number(row[column]).toFixed(2);
        return row[column] || "-";
    };

    const renderDNCards = (dispatchNotes) => (
        < div className="grid grid-cols-1 md:grid-cols-3 gap-3" >
            {
                dispatchNotes.map((dn) => (
                    <div
                        key={dn.id}
                        className="p-3 border border-gray-200 rounded-lg shadow-sm bg-white hover:shadow-md transition-shadow duration-200"
                    >
                        <div className="flex justify-between items-center">
                            <p className="text-xs text-gray-600">DN Code</p>
                            <p className="text-xs font-semibold text-gray-700">
                                {dn.dn_code || "-"}
                            </p>
                        </div>

                        <div className="flex justify-between items-center mt-2">
                            <p className="text-xs text-gray-600">Warehouse</p>
                            <p className="text-xs font-semibold text-gray-700">
                                {dn.warehouse_name || "-"}
                            </p>
                        </div>

                        <div className="flex justify-between items-center mt-2">
                            <p className="text-xs text-gray-600">Raised On</p>
                            <p className="text-xs font-semibold text-gray-700">
                                {formatDateDDMMYYYY(dn.created?.split("T")[0] || "-")}
                            </p>
                        </div>

                        <div className="flex justify-between items-center mt-2">
                            <p className="text-xs text-gray-600">Status</p>
                            <span
                                className={`inline-block mt-0.5 px-2 py-0.5 text-[10px] font-semibold rounded-full ${STATUS_COLORS[dn.status] || "bg-gray-100 text-gray-800"
                                    }`}
                            >
                                {toProperCase(dn.status || "-")}
                            </span>
                        </div>
                    </div>
                ))
            }
        </div >
    );

    const renderDNCardsMob = (dispatchNotes) => (
        <div>
            {dispatchNotes.map((dn) => (
                <div
                    key={dn.id}
                    className="p-3 border border-gray-200 rounded-lg shadow-sm bg-white mt-2">
                    <div className="grid grid-cols-2 gap-x-4 gap-y-2 text-xs text-gray-600">
                        <p><span className="font-medium text-gray-700">{dn.dn_code || "-"}</span> </p>
                        <p><span className="font-medium text-gray-700">{dn.warehouse_name || "-"}</span></p>
                        <p><span className="font-medium text-gray-700"> {formatDateDDMMYYYY(dn.created?.split("T")[0] || "-")}</span></p>
                        <p className="flex items-center">
                            <span
                                className={`inline-block px-2 py-0.5 text-[10px] font-semibold rounded-full ${STATUS_COLORS[dn.status] || "bg-gray-100 text-gray-800"
                                    }`}>
                                {toProperCase(dn.status || "-")}
                            </span>
                        </p>
                    </div>
                </div>

            ))}
        </div>
    );

    return (
        <div className="flex flex-col">
            {activeTab === TABS.DN && (
                <div className="px-4 py-4">
                    {/* Two-column layout */}
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-2">
                            {/* Left Column - Dispatch Notes */}
                            <div>
                                <h3 className="text-lg font-semibold text-primary mb-4 flex items-center gap-1">
                                    <span className="inline-block w-1.5 h-6 bg-primary rounded-full"></span>
                                    Dispatch Notes
                                </h3>
                                <div className="overflow-hidden">
                                    {loadingDN ? (
                                        <Spinner size={4} />
                                    ) : dispatchNotes.length > 0 ? (
                                            <div className="flex-1 pr-6 border-r border-gray-200">
                                                {/*  Desktop View */}
                                                <div className="h-[400px] hidden md:block overflow-y-auto pr-3">
                                                    {renderDNCards(dispatchNotes)}
                                                </div>
                                                <div className="hidden md:block shrink-0 mt-2">
                                                    <Pagination
                                                        page={pageDN}
                                                        rowsPerPage={rowsPerPageDN}
                                                        onPageChange={onPageChangeDN}
                                                        onPageSizeChange={onPageSizeChangeDN}
                                                        totalPages={totalPagesDN}
                                                    />
                                                </div>
                                                {/*  Mobile View */}
                                                <div className="block md:hidden h-[200px] overflow-y-auto pr-2">
                                                    {renderDNCardsMob(dispatchNotes)}
                                                </div>
                                                <div className="block md:hidden shrink-0 mt-2">
                                                    <Pagination
                                                        page={pageDN}
                                                        rowsPerPage={rowsPerPageDN}
                                                        onPageChange={onPageChangeDN}
                                                        onPageSizeChange={onPageSizeChangeDN}
                                                        totalPages={totalPagesDN}
                                                    />
                                                </div>
                                            </div>
                                    ) : (
                                        <p className="text-gray-500">No dispatch notes found for this MRR.</p>
                                    )}
                                </div>
                            </div>
                        {/* Right Column - Material Comparison */}
                        <div>
                            <h3 className="text-lg font-semibold text-primary mb-4 flex items-center gap-2 mt-5">
                                <span className="inline-block w-1.5 h-6 bg-primary rounded-full"></span>
                                Material Comparison
                            </h3>
                            <div className="overflow-x-auto">
                                {loadingDispatch ? (
                                    <Spinner size={4} />
                                ) : dispatchData?.materials?.length > 0 ? (
                                        <div className="h-[400px] overflow-y-scroll md:h-[400px] md:overflow-y-scroll border border-gray-200 rounded-lg shadow-sm">
                                        <GenericTable
                                            tableColumns={dispatchColumns}
                                            columnLabels={dispatchLabels}
                                            tableRows={dispatchData.materials}
                                            renderField={renderDNMRRTable}
                                            enableMobileCardView={false}
                                        />
                                    </div>
                                ) : (
                                    <p className="text-gray-500">No material comparison data available.</p>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default DNComparison;
